import { Typography } from '@mui/material'
import ModalDialog from '../modal-dialog/ModalDialog'

export default function RemoveUserDialog({
    user,
    onConfirm,
    onCancel,
}) {
    const commands = [
        {
            label: 'חזרה',
            testId: 'firm-user-removal-cancel',
            color: 'secondary',
            onClick: onCancel,
        },
        {
            label: 'הסרה',
            testId: 'firm-user-removal-confirm',
            color: 'primary',
            onClick: onConfirm,
        },
    ]

    return (
        <ModalDialog
            open={user != null}
            title="הסרת משתמש מהמשרד"
            commands={commands}
            onClose={onCancel}
        >
            <Typography variant="body2" data-testid="firm-user-removal-dialog">
                {`להסיר את ${user?.username ?? ''} מהמשרד? המשתמש עצמו לא יימחק.`}
            </Typography>
        </ModalDialog>
    )
}
